import { call, put } from "redux-saga/effects";

import actions from "@/actions";
import { Api } from "@/utils";

import { saveLightGroupSettings } from "./save-light-group-settings";

const config = {
    text: {
        publishing: "Publishing settings...",
        success: "Settings saved and published successfully",
        saveError: "Failed to save settings",
        publishError: "Failed to publish settings",
        genericError: "An unexpected error occurred",
    },
};

/**
 * Saves and then publishes the pending light group settings, refreshing the store on success.
 *
 * @yields Calls save and publish APIs and dispatches store updates.
 */
function* saveAndPublishLightGroupSettings() {
    let saved = false;
    let published = false;

    try {
        const settings = yield call(saveLightGroupSettings);

        saved = true;

        yield put(
            actions.map.general.setLightGroupSettingsStatus({
                message: config.text.publishing,
            }),
        );

        yield call(
            Api.post,
            `v1/control-group-settings/${settings.controlGroupSettingsID}/publish`,
            {},
            { parseErrorBody: true },
        );

        published = true;

        const newSettings = yield call(
            Api.get,
            `v1/control-group-settings/control-group-id/${settings.groupID}`,
            {},
            { parseErrorBody: true },
        );

        yield put(actions.map.general.putLightGroupSettings(newSettings));

        yield put(
            actions.map.general.setLightGroupSettingsStatus({
                message: config.text.success,
                success: true,
            }),
        );
    } catch (err) {
        let message = err.cause?.errorBody?.error;

        if (!message) {
            if (!saved) {
                message = config.text.saveError;
            } else if (!published) {
                message = config.text.publishError;
            } else {
                message = config.text.genericError;
            }
        }

        yield put(
            actions.map.general.setLightGroupSettingsStatus({
                message,
                success: false,
            }),
        );
    } finally {
        yield put(actions.map.general.clearPendingLightGroupSettings());
    }
}

export default saveAndPublishLightGroupSettings;
